import { defineStore } from "pinia";

export const useSystemStore = defineStore("systemStore", {
  //composition API の書き方ではないのでまねしないこと
  state: () => {
    return {
      isLoading: false,
    };
  },
  actions: {
    startLoading() {
      this.isLoading = true;
    },
    endLoading() {
      this.isLoading = false;
    },
  },
});
